import { useNewExportConfig, useNewExportOptions } from '@/hooks'
import { CampaignNav, ExportConfigurator } from '@/ui'
import { roleEnum } from '@jobilla/nexus-sdk'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_auth/company/$companyId/$campaignId/export',
)({
	component: RouteComponent,
	beforeLoad: ({ params, context }) => {
		const { auth } = context
		if (!auth.role || !([roleEnum.jobillan, roleEnum.admin] as string[]).includes(auth.role)) {
			throw redirect({
				to: '/company/$companyId/$campaignId/overview',
				params: { companyId: params.companyId, campaignId: params.campaignId },
				replace: true,
			})
		}
	},
})

function RouteComponent() {
	const { campaignId } = Route.useParams()

	useNewExportConfig({ campaignId })
	useNewExportOptions()

	return (
		<CampaignNav activeCampaignNavLink="export">
			<div className="flex items-center justify-center py-12">
				<ExportConfigurator />
			</div>
		</CampaignNav>
	)
}
